export const DELETABLE_BY_SELECTION = new Set([
  "Tree",
  "Flowers",
  "Residence",
  "Condo",
  "Hotel",
  "Business",
  "Rock",
  "Bunker",
  "Teebox",
]);

export const SELECTION_HIGHLIGHT_OPTIONS = {
  color: "#E53935",
  weight: 3,
  dashArray: "4 4",
  fillColor: "#E53935",
  fillOpacity: 0.2,
};

const shapeVertices = (shape) => {
  if (shape?.type === "point") {
    const flat = Array.isArray(shape?.list) ? shape.list.flat(3) : [];
    return flat.length >= 2 ? [[flat[0], flat[1]]] : [];
  }
  if (shape?.type === "line") {
    return Array.isArray(shape?.list?.[0]) ? shape.list[0] : [];
  }
  if (Array.isArray(shape?.list)) {
    return shape.list.flat(1);
  }
  return [];
};

const isValidLatLng = (pair) =>
  Array.isArray(pair) &&
  pair.length >= 2 &&
  Number.isFinite(+pair[0]) &&
  Number.isFinite(+pair[1]);

const allVerticesInside = (bounds, vertices) =>
  vertices.length > 0 &&
  vertices.every(
    (pair) => isValidLatLng(pair) && bounds.contains([+pair[0], +pair[1]])
  );

export const teeCenterLatLng = (tee) => {
  const idx = Number(tee?.id?.split("_")[1]);
  const lat = +tee?.[`teeLat${idx}`];
  const lng = +tee?.[`teeLon${idx}`];
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat === 0 && lng === 0) return null;
  return [lat, lng];
};

export const collectSelection = ({
  bounds,
  courseWiseData,
  holeWiseData,
  teeCenterData,
  selectedHoleNo,
}) => {
  const holeNo = Number(selectedHoleNo);
  const hasSelectedHole = Number.isFinite(holeNo) && holeNo > 0;

  const allShapes = [...(courseWiseData || []), ...(holeWiseData || [])];
  const containedShapes = allShapes.filter(
    (shape) =>
      DELETABLE_BY_SELECTION.has(shape?.label) &&
      allVerticesInside(bounds, shapeVertices(shape))
  );
  const vectorShapes = containedShapes.filter((shape) =>
    shape?.hole > 0 ? hasSelectedHole && Number(shape.hole) === holeNo : true
  );

  const containedTees = (teeCenterData || []).flat().filter((tee) => {
    const latLng = teeCenterLatLng(tee);
    return latLng !== null && bounds.contains(latLng);
  });
  const teeCenters = hasSelectedHole
    ? containedTees.filter((tee) => Number(tee?.holeNumber) === holeNo)
    : [];

  const excludedByHole =
    containedShapes.length -
    vectorShapes.length +
    (containedTees.length - teeCenters.length);

  return { vectorShapes, teeCenters, excludedByHole };
};
